import { useNavigate } from 'react-router-dom'
import { useTranslation } from '../i18n/LanguageContext'

interface AdminHubProps {
  onBack: () => void
}

export default function AdminHub({ onBack }: AdminHubProps) {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const a = t.adminHub

  return (
    <div style={styles.page}>
      <header style={styles.header}>
        <button onClick={onBack} style={styles.backBtn}>{a.back}</button>
        <h1 style={styles.headerTitle}>{a.title}</h1>
      </header>

      <div style={styles.content}>
        <div style={styles.grid}>
          <button style={styles.card} onClick={() => navigate('/admin/themes')}>
            <span style={styles.cardIcon}>🎨</span>
            <span style={styles.cardTitle}>{a.themesTitle}</span>
            <span style={styles.cardDesc}>{a.themesDesc}</span>
          </button>

          <button style={styles.card} onClick={() => navigate('/admin/users')}>
            <span style={styles.cardIcon}>👥</span>
            <span style={styles.cardTitle}>{a.usersTitle}</span>
            <span style={styles.cardDesc}>{a.usersDesc}</span>
          </button>

          <button style={styles.card} onClick={() => navigate('/admin/printables')}>
            <span style={styles.cardIcon}>🖨️</span>
            <span style={styles.cardTitle}>{a.printablesTitle}</span>
            <span style={styles.cardDesc}>{a.printablesDesc}</span>
          </button>

          <button style={styles.card} onClick={() => navigate('/admin/activities')}>
            <span style={styles.cardIcon}>🎮</span>
            <span style={styles.cardTitle}>{a.activitiesTitle}</span>
            <span style={styles.cardDesc}>{a.activitiesDesc}</span>
          </button>

          <button style={styles.card} onClick={() => navigate('/admin/stats')}>
            <span style={styles.cardIcon}>📊</span>
            <span style={styles.cardTitle}>{a.statsTitle}</span>
            <span style={styles.cardDesc}>{a.statsDesc}</span>
          </button>
        </div>
      </div>
    </div>
  )
}

const styles: Record<string, React.CSSProperties> = {
  page: { minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#FAF6EF' },

  header: {
    background: 'linear-gradient(135deg, #1B4332, #2D6A4F)',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    gap: 16,
  },
  backBtn: {
    fontSize: '0.9rem',
    fontWeight: 700,
    color: 'rgba(255,255,255,0.8)',
    background: 'rgba(255,255,255,0.12)',
    border: 'none',
    borderRadius: 10,
    padding: '8px 14px',
    cursor: 'pointer',
    minHeight: 40,
  },
  headerTitle: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: '1.6rem',
    fontWeight: 700,
    color: '#FFFFFF',
    margin: 0,
  },

  content: {
    flex: 1,
    padding: '48px 24px',
    maxWidth: 720,
    width: '100%',
    margin: '0 auto',
    boxSizing: 'border-box',
  },

  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: 24,
  },

  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 8,
    background: '#FFFFFF',
    border: '2px solid #E8DDD0',
    borderRadius: 16,
    padding: '28px 24px',
    cursor: 'pointer',
    textAlign: 'left',
    transition: 'border-color 0.15s, box-shadow 0.15s',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  },

  cardIcon: { fontSize: '2rem', lineHeight: 1 },

  cardTitle: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: '1.4rem',
    fontWeight: 700,
    color: '#1B4332',
  },

  cardDesc: {
    fontFamily: 'Nunito, sans-serif',
    fontSize: '0.9rem',
    color: '#6B5744',
    lineHeight: 1.4,
  },
}
